var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"action-button"},'v-btn',attrs,false),on),[_vm._v(" Action "),_c('v-icon',[_vm._v("mdi-menu-down")])],1)]}}])},[_c('v-list',[_c('v-list-item',{staticClass:"read-list-items",on:{"click":_vm.manageDetach}},[_c('v-list-item-title',[_vm._v("Detach")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }